import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SearchWorkspace from '../routes/workspace';
import TooltipSearch from './search';
import TooltipView from './view';

function componentToState(state) {
  return {
    companyView: state.companyView
  };
}

@withRouter
@connect(componentToState)
class TooltipWorkspace extends Component {
  rootUrl = '/tooltip';

  workSpaces = [
    {
      id: 'search',
      component: TooltipSearch
    },
    {
      id: 'view',
      param: ':id?',
      component: TooltipView
    }
  ];
  render() {
    return <SearchWorkspace rootUrl={this.rootUrl} workSpaces={this.workSpaces} />;
  }
}

export default TooltipWorkspace;
